import React from 'react';
import Form from './SearchForm';
import Movies from './Movies';
import Buttons from './Buttons';
const Home = () => {
  return (
    <main>
      <Form />
      <Movies />
      <Buttons />
    </main>
  );
};

export default Home;
